export function modalCommentatorCreate(setElement) {
  const commentatorData = setElement.dataset.commentator;
  const commentatorText = setElement.dataset.commentatortext;
  const commentatorImg = setElement.querySelector('.js-modalProfImg').getAttribute('src');
  const commentatorName = setElement.querySelector('.js-modalProfName').textContent;
  const commentatorProfFacultyAll = setElement.querySelectorAll('.js-modalProfFaculty');
  const commentatorProfTheme = setElement.querySelector('.js-modalProfTheme').textContent;
  const commentatorProfThemeAll = setElement.querySelectorAll('.js-modalProfTheme');
  const commentatorProfResearchAll = setElement.querySelectorAll('.js-modalProfResearch');
  const commentatorProfField = setElement.dataset.commentatorcat;

  const fieldArray = commentatorProfField.split('/');
  let fieldSetData;

  for (let i = 0; i < fieldArray.length; i++) {
    if (i == 0) {
      fieldSetData = '<li class="c-alignLabel_item"><span class="c-label u-clrBg--white">' + fieldArray[i] + '</span></li>';
    } else {
      if (fieldArray[i]) {
        fieldSetData += '<li class="c-alignLabel_item"><span class="c-label u-clrBg--white">' + fieldArray[i] + '</span></li>';
      }
    }
  }

  // 学部のHTML要素作成
  const setFaculty = document.createElement('p');
  createModalEle(setFaculty, commentatorProfFacultyAll);

  // 研究テーマのHTML要素作成
  const setTheme = document.createElement('p');
  createModalEle(setTheme, commentatorProfThemeAll);

  // 研究分野のHTML要素作成
  const setResearch = document.createElement('p');
  createModalEle(setResearch, commentatorProfResearchAll);

  // モーダル内に設置する要素の生成
  const modalCreate = document.createElement('div');
  modalCreate.className = 'c-modal_box';
  modalCreate.innerHTML =
    '<div class="p-commentatorModal"><div class="p-commentatorModal_media"><div class="p-commentatorModal_mediaBox"><p class="c-headingSize34 c-headingLine u-ff--shipporiMincho">' +
    commentatorName +
    '</p><div class="p-commentatorModal_mediaBoxInner"><dl class="p-commentatorModal_info"><dt class="c-textSize16 p-commentatorModal_infoHead u-clr--blueNavy u-fw--600">学部</dt><dd class="c-textSize15 p-commentatorModal_infoBody">' +
    setFaculty.outerHTML +
    '</dd></dl><dl class="p-commentatorModal_info"><dt class="c-textSize16 p-commentatorModal_infoHead u-clr--blueNavy u-fw--600">研究分野</dt><dd class="c-textSize15 p-commentatorModal_infoBody">' +
    setResearch.outerHTML +
    '</dd></dl><dl class="p-commentatorModal_info"><dt class="c-textSize16 p-commentatorModal_infoHead u-clr--blueNavy u-fw--600">研究テーマ</dt><dd class="c-textSize15 p-commentatorModal_infoBody">' +
    setTheme.outerHTML +
    '</dd></dl></div></div><div class="p-commentatorModal_mediaImg"><img src="' +
    commentatorImg +
    '" alt=""></div></div><div class="p-commentatorModal_feature"><p class="c-headingSize20 c-headingIco">得意な分野、可能なコメント</p><ul class="c-alignLabel u-pt--20">' +
    fieldSetData +
    '</ul><p class="c-textSize15 p-commentatorModal_featureText u-pt--16">' +
    commentatorText +
    '</p></div><ul class="p-commentatorModal_btn"><li class="p-commentatorModal_btnBox"><div class="c-btnBasic"><a href="https://bhfb.f.msgs.jp/webapp/form/21139_bhfb_6/index.do" class="c-btnArrowAfter c-btnArrowAfter--external" target="_blank" rel="noopener"><span class="c-btnArrowAfter_text">取材・メディア出演のお問い合わせ</span><span class="c-btnArrowAfter_item"></span></a></div></li><li class="p-commentatorModal_btnBox"><div class="c-btnBasic"><a href="' +
    commentatorData +
    '" class="c-btnArrowAfter"><span class="c-btnArrowAfter_text">教員情報</span><span class="c-btnArrowAfter_item"></span></a></div></li></ul></div>';

  return modalCreate;

  function createModalEle(element, all) {
    element.className = 'c-data';

    all.forEach((target) => {
      const thisText = target.textContent;
      element.innerHTML += '<span class="c-data_item">' + thisText + '</span>';
    });
  }
}
